<template>
  <div class="monitor-list">
    <el-input placeholder="请输入关键字" v-model="input">
      <template slot="append">搜索</template>
    </el-input>
    <div class="listTop flex_bc">
      <div class="child1">设备</div>
      <div class="child2">监控地点</div>
      <div class="child3">设备状态</div>
    </div>
    <div class="scroll-box">
      <!-- @click="clickProps($event)" -->
      <ul>
        <!-- <vue-seamless-scroll :data="list" :class-option="classOption"> -->
        <li
          class="flex_bc"
          :id="item.id"
          v-for="item in lists"
          :key="item.id"
          @click="handleLi(item.name)"
        >
          <div class="child1" :title="item.name">{{ item.name }}</div>
          <div class="child2" :title="item.title">
            {{ item.title || '暂无数据' }}
          </div>
          <div
            class="child3"
            :style="{ color: item.site == 1 ? '#00FFA5' : '#EA5050' }"
          >
            {{ item.site == 1 ? '在线' : '离线' }}
          </div>
        </li>
        <!-- </vue-seamless-scroll> -->
      </ul>
    </div>
  </div>
</template>
<script>
  // import vueSeamlessScroll from 'vue-seamless-scroll'
  export default {
    name: 'monitor-list',
    props: {
      M_list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    // components: { vueSeamlessScroll },
    data() {
      return {
        input: '',
        lists: [
          // {
          //   name: 'cb1d7e62aea14fd094593916ed574a34',
          //   title: '巩留旅游库尔德宁监控',
          //   site: 1,
          //   id: 1,
          // },
          // {
          //   name: 'a69ca5aaf42d4ad29d6608f72bb471c7',
          //   title: '安居尔花苑生活区',
          //   site: 1,
          //   id: 2,
          // },
          // {
          //   name: '0188f20058994971ad050fd3f6d7f1da',
          //   title: '伊宁市贝语新城售楼中心VIP室',
          //   site: 1,
          //   id: 1,
          // },
          // {
          //   name: '288a464800bd4f0baf17d57cd73ec1f7',
          //   title: '伊宁市贝语新城售楼中心东南角',
          //   site: 1,
          //   id: 2,
          // },
          // {
          //   name: '7846e240cfad44edb530ef34f7aa20c4',
          //   title: '伊宁市贝语新城售楼中心西北角',
          //   site: 1,
          //   id: 3,
          // },
          // {
          //   name: 'ae61fa794dc941d5ab998fd3361e8805',
          //   title: '伊宁市恒大绿洲四期14#15#大门',
          //   site: 1,
          //   id: 4,
          // },
          // {
          //   name: 'c452eaed40ac4620836cd144b05169a8',
          //   title: '伊宁市恒大绿洲四期14#15#大门外',
          //   site: 1,
          //   id: 5,
          // },
        ],
        listLoading: true,
      }
    },
    watch: {
      M_list(v) {
        // this.lists = v
        console.log(v, '看烧烤店看')
        // console.log(v)
        // console.log(this.lists)
      },
    },
    computed: {
      // classOption() {
      //   return {
      //     step: 0.2, // 数值越大速度滚动越快
      //     limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
      //     hoverStop: true, // 是否开启鼠标悬停stop
      //     direction: 1, // 0向下 1向上 2向左 3向右
      //     openWatch: true, // 开启数据实时监控刷新dom
      //     singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
      //     singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
      //     waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      //   }
      // },
    },
    created() {
      // this.list = Array.from({ length: 30 }, (v, i) => i + 1)
    },
    methods: {
      setList(list) {
        console.log(list, '可搜集的')
        this.listLoading = false
        this.lists = list
      },
      // 点击每一项
      handleLi(code) {
        this.$emit('childCode', code)
      },
      clickProps(e) {
        let path = e.path
        if (path) {
          this.$emit('childCode', path[1].id)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .monitor-list {
    @mixin text_style {
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .listTop {
      @include text_style;
      background: rgba(122, 255, 213, 0.1);
      color: #87caa8;
      margin-top: 20px;
    }
    .scroll-box {
      height: 66vh;
      overflow: hidden;
    }
    ul {
      li {
        @include text_style;
        color: #fff;
      }
      li:nth-child(odd) {
        background: rgba(255, 255, 255, 0.05);
        border-bottom: 1px solid #535556;
        border-top: 1px solid #535556;
      }
    }
    .listTop,
    li {
      div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
    .child1 {
      text-align: left;
      padding-left: 20px;
      flex: 0 20%;
    }
    .child2 {
      flex: 0 50%;
      margin: 0 5%;
    }
    .child3 {
      flex: 0 20%;
    }
  }

  ::v-deep {
    .el-input__inner {
      border-color: #49ba90;
      background-color: #0e3428;
      color: #fff;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      cursor: pointer;
      background-color: #24d996;
      color: #fff;
      border-color: #49ba90;
    }
  }
</style>
